<template>
    <section>
        <div class="container">        
            <CommonBreadcrumb class="bread_block_mod" /> 
        </div>
        <div class="container-fluid px-0">
            <div class="guide_block_banner">
                <div class="eng_guide_banner">
                    <picture>
                    <source width="1920" height="540" type="image/webp" srcset="~/assets/eng-guide/step_two/banner.webp">
                    <img height="540" width="1920" type="image/jpeg" src="~/assets/eng-guide/step_two/banner.jpg" alt="Types of Diamonds">
                    </picture>

                    <div class="eng_guide_upper">
                        <h2>Step 3</h2>
                        <h4 class="font-active">Choose A Diamond</h4>
                        <p class="mb-0" v-if="$country.is_india">That perfect moment, the hint of a surprise and the happiness of a 'YES' – all begin when you find the 'right' diamond. Your search for that beautiful, perfect rock ends at Friendly Diamonds.</p>
                        <p class="mb-0" v-else>That perfect moment, the hint of a surprise, the happiness of a 'YES' all begins when you find the 'right' diamond. Your search for that beautiful, perfect rock ends at Friendly Diamonds.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-lg mt-5">
            <div class="guide_block pb-4">
                <h1 class="mb-3 font-active">choose types of diamonds</h1>
                <p v-if="$country.is_india">
                    You can choose different types of diamonds: round, emerald, princess, pear, heart, asscher, cushion, oval, radiant and marquise cuts. Each diamond type is as beautiful as the other and tells a different story regarding your <NuxtLink :to="localePath('/engagement-rings')"> engagement ring</NuxtLink>.
                    <br><br>
                    Each cut has a specific feature that'll suit your preferences according to how you'd like your ring to look and shine. For example, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">round-shaped diamonds</NuxtLink> are a classic type of diamond with the most brilliance and shine. And <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })">oval-shaped diamonds</NuxtLink> are a trending modern cut that adds more length to the wearer's fingers.
                </p>
                <p v-else>
                    You can choose different types of diamonds: round, emerald, princess, pear, heart, asscher, cushions, oval, radiant, and <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'marquise-cut-diamond' } })">marquise cuts</NuxtLink>. Each diamond type is as beautiful as the other and tells a different story regarding your <NuxtLink :to="localePath('/engagement-rings')">engagement ring</NuxtLink>.
                    <br><br>
                    Each cut has a specific feature that'll suit your preferences according to how you'd like your ring to look and shine. For example, <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'round-cut-diamond' } })">round-shaped diamonds </NuxtLink> are a classic type of diamond with the most brilliance and shine. And <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'oval-cut-diamond' } })">oval-shaped diamonds</NuxtLink> are a trending modern cut that adds more length to the wearer's fingers.
                </p>
                <CommonShapeSlider />
            </div>
            
            <div class="guide_block pt-4">
                <h2 class="mb-3 font-active">4C's of a diamond: cut, color, clarity and carat</h2>
                <p v-if="$country.is_india">
                    Before choosing your diamond, you must know everything there is to know about your diamond. The <NuxtLink :to="localePath('/4-cs-diamond')">Diamond 4 C’s</NuxtLink> give you the necessary insight into your purchase, as it is a grading system that details and outlines your diamond’s quality and price.
                </p>
                <p v-else>
                    Before choosing your diamond you must know everything there is to know about your diamond. <NuxtLink :to="localePath('/4-cs-diamond')">The Diamond 4Cs</NuxtLink> gives you the necessary insight into your purchase as it is a grading system that details and outlines your diamond’s quality and price.
                </p>
                <!-- <b-img loading="lazy" class="my-3" height="540" width="500" src="~/assets/eng-guide/step_two/diamond_4cs_banner.webp" alt=""></b-img> -->
            </div>

            <div class="row guide_block align-items-center py-4">
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_two/diamond_cut.webp">
                        <img loading="lazy" class="my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/diamond_cut.jpg" alt="Diamond CUT">
                    </picture>
                </div>
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Diamond CUT</h4>
                    <p v-if="$country.is_india">A diamond's sparkle is based on how well the facets are cut and how well the facets interact with light, making the diamond cut an important feature when choosing your diamond. The diamond cut basically defines the beauty of your gemstone and is one of the most important C’s when it comes to your diamond.
                    At Friendly Diamonds, you can choose from a super-sized inventory of brilliant, sparkly diamonds perfect for your engagement ring.</p>
                    <p v-else>A diamond's sparkle is based on how well the facets are cut and how well the facets interact with light making the diamond cut an important feature when choosing your diamond. <br> The <NuxtLink :to="localePath('/blog/types-of-diamond-cut-shape')">diamond cut</NuxtLink> basically defines the beauty of your gemstone and is one of the most important C’s when it comes to your diamond. <br>At Friendly Diamonds, you can choose from a super-sized inventory of brilliant sparkly diamonds perfect for your engagement ring.</p>
                    <NuxtLink class="radious_four" :to="localePath('/4-cs-diamond#cut')">Know more about Diamond Cut</NuxtLink>
                </div>
            </div>

            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Diamond CLARITY</h4>
                    <p v-if="$country.is_india">
                        Diamonds can have inclusions inside and blemishes on the surface. They affect the gemstone's visual appearance; hence, diamonds have to be graded for their clarity. Diamond clarity grades range from I (Inclusions) to FL (Flawless). (I) stands for inclusions, which refers to diamonds with the most inclusions and is at the bottom of the diamond clarity scale. And (FL) stands for flawless, referring to flawless diamonds at the top of the diamond clarity scale.
                    </p>
                    <p v-else>
                        Diamonds can have inclusions inside and blemishes on the surface. They affect the gemstone's visual appearance; hence, diamonds have to be graded for their clarity. 
                        <NuxtLink :to="localePath('/blog/what-is-diamond-grading')">Diamond clarity grades</NuxtLink> range from I (Inclusions) to FL (Flawless). (I) stands for inclusions, which refers to diamonds with the most inclusions and is at the bottom of the diamond clarity scale. And (FL) stands for flawless, referring to flawless diamonds at the top of the diamond clarity scale.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath('/4-cs-diamond#clarity')">Know more about Diamond Clarity</NuxtLink>
                </div>
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_two/diamond_clarity.webp">
                        <img loading="lazy" class="img-fluid my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/diamond_clarity.jpg" alt="Diamond CLARITY">
                    </picture>
                </div>
            </div>
            
            <div class="row guide_block align-items-center py-4">
                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_two/diamond_color.webp">
                        <img loading="lazy" class="img-fluid my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/diamond_color.jpg" alt="Diamond COLOR">
                    </picture>
                </div>

                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active" v-if="$country.is_india">Diamond COLOUR</h4>
                    <h4 class="mb-3 font-active" v-else>Diamond COLOR</h4>
                    <div v-if="$country.is_india">
                        <p>
                            Diamonds are available in many colours. They are classified as white, practically coloured diamonds or fancy colours. Diamond colour distinctions are so subtle that only a trained gemologist can colour grade the gem. A diamond's price value can rise or fall based on the intensity and hue of the colour.
                        </p>
                        <br><br>
                        <h5 class="pt-3">The Diamond colour grading scale ranges from D to Z.</h5>
                        <p>
                            <b>D, E, F:</b> colour-graded diamonds are colourless diamonds but not always of the best value. <br>
                            <b>G, H, I:</b> colour-graded diamonds are also clear and have the perfect balance of quality and value.<br>
                           <b> J, K, L:</b> diamonds have a slightly warm tint and are sometimes considered diamonds of value depending on other factors.<br>
                           <b> M to Z:</b> diamonds have a noticeably yellow, brown or blue tint.<br>
                        </p>
                    </div>
                    <div v-else>
                        <p>Diamonds are available in many colors. They are classified as white, practically colorless diamonds, or fancy colors. Diamond color distinctions are so subtle that only a trained gemologist can color grade the gem. A diamond's price value can rise or fall based on the intensity and hue of the color.</p>
                        <h5 class="pt-3">The Diamond color grading scale ranges from D to Z.</h5>
                        <p class="my-4">
                            <b>D, E, F:</b> <NuxtLink :to="localePath('/blog/g-h-color-diamond')"> color-graded diamonds</NuxtLink> are colorless diamonds but not always of the best value. <br>
                            <b>G, H, I:</b> color-graded diamonds are also clear and have the perfect balance of quality and value. <br>
                            <b>J, K, L:</b> diamonds have a slightly warm tint and are sometimes considered diamonds of value depending on other factors. <br>
                            <b>M to Z:</b> diamonds have a noticeably yellow, brown or blue tint.
                        </p>
                    </div>
                    <NuxtLink class="radious_four" :to="localePath('/4-cs-diamond#color')">Know more about Diamond Color </NuxtLink>
                </div>
            </div>

            <div class="row guide_block align-items-center py-4 row_mod">
                <div class="col-md-7 col-12">
                    <h4 class="mb-3 font-active">Diamond CARAT WEIGHT</h4>
                    <p v-if="$country.is_india">
                        Diamond carat weights are not to be confused with diamond size. Diamond size refers to how big your diamond is. Carat weight refers to the weight of your diamond. The weight is measured in carats. One metric carat equals 200 milligrammes. The heavier the carat weight, the costlier the diamond, as large diamonds are not easy to procure.
                    </p>
                    <p v-else>
                        Diamond carat weights are not to be confused with diamond size. Diamond size refers to how big your diamond is. Carat weight refers to the weight of your diamond. The weight is measured in carats. One metric carat equals 200 milligrams. The more the carat weight, the costlier the diamond, as large diamonds are not easy to procure.
                    </p>
                    <NuxtLink class="radious_four" :to="localePath('/4-cs-diamond#carat')">Know more about Diamond Carat Weight</NuxtLink>
                </div>

                <div class="col-md-5 col-12 text-center">
                    <picture>
                        <source width="550" height="550" type="image/webp" srcset="~/assets/eng-guide/step_two/diamond_carat.webp">
                        <img loading="lazy" class="img-fluid my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/diamond_carat.jpg" alt="Diamond CARAT WEIGHT">
                    </picture>
                </div>
            </div>

            <div>
                <h6 v-if="$country.is_india">Besides the diamond 4 C's, we also have another 2 C's that are not a part of the actual diamond anatomy but are equally important in the modern-day. The 2 C's refer to Certificate and Conscience.</h6>
                <h6 v-else>Besides the diamond 4 Cs, we also have another 2 Cs that are not part of the actual diamond anatomy but are equally important in modern modern-day. The 2 Cs refer to Certificate and Conscience.</h6>
            </div>

            <div class="row guide_block py-4">
                <div class="col-md-6 col-12">
                    <div class="text-center">
                        <picture>
                            <source width="600" height="400" type="image/webp" srcset="~/assets/eng-guide/step_two/certification.webp">
                            <img loading="lazy" class="img-fluid my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/certification.jpg" alt="Certification">
                        </picture>
                    </div>
                    <h4 class="my-3 font-active">Certification</h4>
                    <p v-if="$country.is_india">Your diamond is certified based on the 4 C’s by independent labs like <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">GIA</NuxtLink>, GCAL and <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">IGI</NuxtLink>. These labs provide certificates that give you complete details about your diamond's quality. Always ask your online jeweller for a diamond certificate so that you know the actual value of your diamond purchase.</p>
                    <p v-else>Your diamond is certified based on the 4Cs by independent labs like GIA, GCAL, and IGI. These labs provide certificates that give you complete details of your diamond's quality. Always ask your online jeweler for a diamond certificate so that you know the actual value of your diamond purchase.</p> 
                </div>

                <div class="col-md-6 col-12">
                    <div class="text-center">
                        <picture>
                            <source width="600" height="400" type="image/webp" srcset="~/assets/eng-guide/step_two/conscience.webp">
                            <img loading="lazy" class="img-fluid my-3 radious_eight" height="550" width="550" type="image/jpeg" src="~/assets/eng-guide/step_two/conscience.jpg" alt="Conscience">
                        </picture>
                    </div>

                    <h4 class="my-3 font-active">Conscience</h4>
                    <p v-if="$country.is_india">The C of conscience refers to the purchase of responsible diamonds. Over the years, the diamond mining industry has been known for unethical practices related to blood diamonds and human rights issues. The industry is also known for its detrimental effects on the environment. Choosing a <NuxtLink :to="localePath('/lab-diamonds')">lab diamond</NuxtLink> ensures a smaller carbon footprint on the planet, making it an ethical, sustainable and environmentally conscious purchase.</p>
                    <p v-else>The C of conscience refers to the purchase of responsible diamonds. The diamond mining industry, over the years, has been known for unethical practices related to blood diamonds and human rights issues. The industry is also known for its detrimental effects on the environment. Choosing a <NuxtLink :to="localePath('/')">lab diamond</NuxtLink> ensures a smaller carbon footprint on the planet, making it an ethical, sustainable, and environmentally conscious purchase.</p>
                </div>
            </div>
    
            <div class="row cta_block">
                <div class="col-12 mx-auto px-0 d-flex align-items-center justify-content-center font-active" >
                    <NuxtLink :to="localePath('/engagement-ring-guide/types-of-ring-settings')">
                        Choose Setting <div class="arrow_eng">
                            <SvgHeaderSvg :type="'left'" /></div> Back
                    </NuxtLink>
                    <span class="mx-2">|</span>
                    <NuxtLink :to="localePath('/engagement-ring-guide/complete-the-ring')" >
                        Next <div class="arrow_eng">
                            <SvgHeaderSvg :type="'right'" /></div> Complete the Ring
                    </NuxtLink>
                </div>
            </div>
            
        </div>
    </section>
</template>

<script setup>
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.arrow_eng svg.svg-head {
    height: 13px;
    width: 12px;
    margin: 0 10px;
}
.eng_guide_banner {
    position: relative;
}
.eng_guide_upper {
    position: absolute;
    top: 50%;
    left: 20%;
    width: 25%;
    transform: translate(-50%,-50%);
}
 .eng_guide_upper h2 {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h4 {
    font-size: 32px;
    color: var(--green);
    font-weight: 500;
    text-transform: capitalize;
}
.eng_guide_upper h4 span{
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    color: #000;
    display: block;
    font-family: Lato;
    margin-bottom: 2%;
}
.eng_guide_upper p {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    line-height: 1.8;
}
.eng_guide_flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.eng_guide_flex a {
    display: inline-block;
    font-size: 14px;
    padding: 1.5% 5%;
    color: #000;
    text-transform: unset;
    font-weight: 400;
    border: 1px solid #000;
}
/* -------cta */
.row.cta_block a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 18px;
}
.row.cta_block span {
    font-size: 25px;
    margin: 0 15px;
    font-weight: 300;
}
.row.cta_block {
    margin: 4% 0;
}
/* -------cta */
@media(max-width:1350px ){
    .eng_guide_upper{
        width: 30%;
        left: 20%;
    }
}
@media(max-width:1024px ){
    .eng_guide_upper h4 {
        font-size: 32px;
    }
    .eng_guide_banner img {
        height: 45vh;
        object-fit: cover;
        object-position: 100%;
    }
}
@media(max-width:992px ){
    .eng_guide_banner img{
        display: none;
    }
    .eng_guide_upper {
        width: 100%;
        left: 0;
        transform: unset;
        position: relative;
        top: 0;
    }
    .guide_block_banner {
        padding: 0 36px 5% 36px;
        border-bottom: 1px solid #ccc;
    }
     /* -------cta */
     .row.cta_block a {
        font-size: 16px;
    }
    /* -------cta */
}
@media(max-width:767px ){
    .arrow_eng {
        /* font-size: 40px; */
    }
    .eng_guide_upper h4 {
        font-size: 32px;
    }
    .guide_block_banner {
        padding: 0% 18px 8% 18px;
        border-bottom: 1px solid #ccc;
    }
    /* -------cta */
    .row.cta_block a {
        font-size: 14px;
    }
    /* -------cta */
}
/* -------------------------------------------------------------- */

.guide_block h2, .guide_block h1 {
    font-size: 32px;
    text-transform: capitalize;
    color: var(--green);
}
.guide_block h5 {
    font-size: 16px;
    font-weight: 600;
    color: #6a6161;
}

.guide_block h4 {
    font-size: 26px;
}
 h6 {
    text-align: center;
    font-size: 24px;
    padding: 5%;
    color: #6a6161;
    line-height: 1.5;
}
.guide_block h4 span{
    color: var(--green);
}
.guide_block p {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
.guide_block p a {
    background: none;
    padding: 0;
    font-size: 16px;
    text-transform: unset;
    color: #6a6161;
    font-weight: 500;
    border: 0;
    text-decoration: underline;
    color: var(--green);
}
.guide_block h3 {
    font-size: 16px;
    font-weight: 600;
    color: var(--green);
}
.guide_block a {
    display: inline-block;
    font-size: 14px;
    padding: 10px 20px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
}
.guide_block ul li {
    font-size: 16px;
    color: #6a6161;
    font-weight: 500;
}
@media(max-width: 992px){
    .guide_block h2, .guide_block h1 {
        font-size: 26px;
        margin-top: 4%;
    }
    h6 {
        font-size: 20px;
    }
}

@media(max-width: 767px){
    .row_mod {
        flex-direction: column-reverse;
    }

    .guide_block h2, .guide_block h1 {
        font-size: 24px;
        margin-top: 6%;
    }
    .guide_block h4{
        font-size: 24px;
    }
    .guide_block p {
        margin: 3% 0 !important;
    }
    .guide_block a {
        margin-top: 5%;
    }
    .guide_block h3 {
        font-size: 16px;
    }
  
    h6 {
        font-size: 18px;
        padding: 5% 0;
    }
}
</style>
